import { render, staticRenderFns } from "./profile.component.html?vue&type=template&id=35cc3ca6&scoped=true&external"
import script from "./profile.component.ts?vue&type=script&lang=ts&external"
export * from "./profile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./profile.component.scss?vue&type=style&index=0&id=35cc3ca6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc3ca6",
  null
  
)

export default component.exports